<mat-card class="m-20 mat-elevation-z4">
  <mat-card-header>
    <mat-card-title>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.TITULO' | translate}}</mat-card-title>
    <mat-card-subtitle>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.SUBTITULO' | translate}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.INPUTS.MAIL' | translate}}</mat-label>
        <input matInput [(ngModel)]="cambioCorreo.correo" [disabled]="aptoCambio">
        <mat-icon matSuffix class="secondary-text">alternate_email</mat-icon>
      </mat-form-field>
      <button mat-raised-button class="ml-20" (click)="cambiarEmail_paso1()" [disabled]="!regexEmail.test(cambioCorreo.correo) || aptoCambio">
        {{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.BOTONES.CAMBIAMAIL' | translate}}
      </button>
    </div>
    <ng-container *ngIf="aptoCambio">
      <div class="" fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.INPUTS.TOKEN' | translate}}</mat-label>
          <input matInput [(ngModel)]="cambioCorreo.codigo" [disabled]="statusCodigo">
          <mat-icon matSuffix class="secondary-text">textsms</mat-icon>
        </mat-form-field>
        <button mat-raised-button class="ml-20" (click)="cambiarEmail_paso2()" [disabled]="statusCodigo">
          {{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.BOTONES.VERTOKEN' | translate}}
        </button>
      </div>
      <ng-container *ngIf="statusCodigo">
        <div class="" fxLayout="row" fxLayoutAlign="space-between center">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.INPUTS.PASS' | translate}}</mat-label>
            <input matInput type="password" [(ngModel)]="cambioCorreo.contrasenia">
            <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
          </mat-form-field>
        </div>
        <div class="" fxLayout="row" fxLayoutAlign="space-between center">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.INPUTS.CONFIRMPASS' | translate}}</mat-label>
            <input matInput type="password" [(ngModel)]="cambioCorreo.confirmarPass">
            <mat-icon matSuffix class="secondary-text">check</mat-icon>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center">
          <button mat-raised-button color="primary" *ngIf="cambioCorreo.contrasenia && cambioCorreo.confirmarPass" (click)="cambiarEmail_paso3()">
            {{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.BOTONES.FINALMAIL' | translate}}
          </button>
        </div>
      </ng-container>
    </ng-container>
  </mat-card-content>
</mat-card>
<mat-card class="m-20 mat-elevation-z4">
  <mat-card-header>
    <mat-card-title>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARPASS.TITULO' | translate}}</mat-card-title>
    <mat-card-subtitle>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARPASS.SUBTITULO' | translate}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.INPUTS.PASS' | translate}}</mat-label>
        <input matInput type="password" [(ngModel)]="cambioPass.contrasenia">
        <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
      </mat-form-field>
    </div>
    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARMAIL.INPUTS.CONFIRMPASS' | translate}}</mat-label>
        <input matInput type="password" [(ngModel)]="cambioPass.confirmarPass">
        <mat-icon matSuffix class="secondary-text">check</mat-icon>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
      <button mat-raised-button color="primary" *ngIf="cambioPass.contrasenia && cambioPass.confirmarPass" (click)="cambiarPass()">
        {{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.CAMBIARPASS.BOTONES.FINALPASS' | translate}}
      </button>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="m-20 mat-elevation-z4">
  <mat-card-header>
    <mat-card-title>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.AUTENTICACION.TITULO' | translate}}</mat-card-title>
    <mat-card-subtitle>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.AUTENTICACION.SUBTITULO' | translate}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="center center">
      <p>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.AUTENTICACION.BOTONES.DESACTIVAR' | translate}}</p>
      <mat-slide-toggle [(ngModel)]="status2FA" (change)="set2FAStatus()" class="ml-20 mr-20"></mat-slide-toggle>
      <p>{{'PERFIL_USUARIO.PAGINAS.configuracion.OPCIONES.AUTENTICACION.BOTONES.ACTIVAR' | translate}}</p>
    </div>
  </mat-card-content>
</mat-card>
